import React, {Component} from 'react';
import moment from 'moment';
import {
  fetchSalaryReceiptData
} from 'actions/SalaryActions'

class Receipt extends Component {
  state = {
    loading: true,
    error: false
  }

  pricing = (price) => {
    var part = price.toFixed(2).toString().split(".")[1];
    return [price.toLocaleString(), part].join(".")
  }

  componentDidMount() {
    let {uid, year, month} = this.props.params;
    fetchSalaryReceiptData(uid, year, month)
      .then((response) => {
        this.setState({
          loading: false,
          ...response.data
        })
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: true
        })
      })
  }
  render() {
    let {
      userData, 
      daliySalary,
      leaveOfMonth,
      normalWU,
      otWU,
      payList,
      deductList,
      uid
    } = this.state;

    let {year, month} = this.props.params;
    let startOfMonth = moment(year+month+"01", 'YYYYMMDD').format("YYYY年MM月DD日")
    let endOfMonth = moment(year+month+"01", 'YYYYMMDD').endOf('month').format("YYYY年MM月DD日")
    let payTotal = 0;
    let deductTotal = 0;

    return (!this.state.loading && 
      (
        this.state.error?
        <div className="receipt-report">
          <h4>
            報告不存在
          </h4>
        </div>
        :
        <div className="receipt-report">
          <h4>支付報酬單據</h4>
          <table className="data-table">
            <tbody>
              <tr>
                <td className="section-header" rowSpan={2}>
                  僱主資料
                </td>
                <td>
                  名稱：{userData.ownerName}
                </td>
                <td className="data-col">
                  聯絡電話：{userData.contact}
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  辦公地址：{userData.address}
                </td>
              </tr>
              <tr>
                <td className="section-header" rowSpan={3}>
                  僱員資料
                </td>
                <td>
                  名稱：{userData.userName}
                </td>
                <td className="data-col">
                  職位：{userData.position}
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  社會保障基金受益人編號：{userData.beneficiaryID}
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  法例規定給予偏員的其他編號：{uid}
                </td>
              </tr>
              <tr>
                <td className="section-header">
                  與所獲報酬<br />相應的期間
                </td>
                <td colSpan={2}> 
                  {startOfMonth} 至 {endOfMonth}
                </td>
              </tr>
            </tbody>
          </table>
          <table className="amount-table">
            <tbody>
              <tr>
                <td className="section-header" rowSpan={5 + payList.length}>
                  報酬
                </td>
                <td>
                  名稱
                </td>
                <td className="amount-col">
                  金額
                </td>
              </tr>
              <tr>
                <td>
                  日薪 MOP$ {this.pricing(daliySalary)}
                </td>
                <td>
                </td>
              </tr>
              <tr>
                <td>
                  工作日數：{normalWU}日
                </td>
                <td>
                  MOP$ {this.pricing(normalWU * daliySalary)}
                </td>
              </tr>
              <tr>
                <td>
                  加班工數：{otWU}日
                </td>
                <td>
                  MOP$ {this.pricing(otWU * daliySalary)}
                </td>
              </tr>
              <tr>
                <td>
                  假期 {leaveOfMonth}日
                </td>
                <td>
                </td>
              </tr>
              {
                payList.map(pay => {
                  let {amount, type, note} = pay;
                  payTotal += amount
                  return(
                    <tr>
                      <td>
                        {type}
                        {note && " - " + note}
                      </td>
                      <td>
                        MOP${this.pricing(amount)}
                      </td>
                    </tr>
                  )
                })
              }
              <tr>
                <td className="sub-total" colSpan={2}>
                  總報酬:
                </td>
                <td>
                  MOP$ {this.pricing((normalWU + otWU) * daliySalary + payTotal)}
                </td>
              </tr>
              <tr>
                <td className="section-header" rowSpan={1 + (deductList.length || 1) }>
                  扣除
                </td>
                <td>
                  名稱
                </td>
                <td>
                  金額
                </td>
              </tr>
              {
                deductList.map(deduct => {
                  let {type, note, amount} = deduct;
                  amount = Math.abs(amount);
                  deductTotal += amount
                  return (
                    <tr>
                      <td> 
                        {type}
                        {note && " - " + note}
                      </td>
                      <td>
                        MOP$ {this.pricing(amount)}
                      </td>
                    </tr>
                  )
                })
              }
              {
                deductList.length === 0 &&
                  <tr>
                    <td> 
                    </td>
                    <td>
                      MOP$ 0.00
                    </td>
                  </tr>
              }
              <tr>
                <td className="sub-total" colSpan={2}>
                  總扣除:
                </td>
                <td>
                  MOP${this.pricing(deductTotal)}
                </td>
              </tr>
            </tbody>
          </table>
          <table className="total-table">
            <tbody>
              <tr>
                <td className="header">
                  總收入
                </td>
                <td className="header">
                  總扣除
                </td>
                <td className="header">
                  淨收入
                </td>
              </tr>
              <tr>
                <td>
                  MOP$ {this.pricing((normalWU + otWU) * daliySalary + payTotal)}
                </td>
                <td>
                  MOP$ {this.pricing(deductTotal)}
                </td>
                <td>
                  MOP$ {this.pricing((normalWU + otWU) * daliySalary + payTotal - deductTotal)}
                </td>
              </tr>
            </tbody>
          </table>        
        </div>
      )
    )
  }
}

export default Receipt;


// WEBPACK FOOTER //
// ./src/components/Report/Receipt.js